import { graphql, HttpResponse } from 'msw'
import {
  type EnrollmentDisclosuresCompanionData,
  type EnrollmentDisclosuresCompanionSubmitOutput,
} from '../../../models'

export const getEnrollmentDisclosuresCompanionDataMock: EnrollmentDisclosuresCompanionData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/brokerage/companion/disclosures',
  enrollmentData: {
    experimentId: 'COMPANION_BROKERAGE',
    investmentProfile: {
      account: {
        includeCompanionAccount: true,
      },
    },
  },
}

export const submitEnrollmentDisclosuresCompanionDataMock: EnrollmentDisclosuresCompanionSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: 'enrollment/investments/brokerage/companion/welcome',
}

export const mockGetEnrollmentDisclosuresCompanionData = graphql.mutation(
  'getEnrollmentDisclosuresCompanionData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentDisclosuresCompanionDataMock } })
  },
)

export const mockSubmitEnrollmentDisclosuresCompanionData = graphql.mutation(
  'submitEnrollmentDisclosuresCompanionData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentDisclosuresCompanionDataMock } })
  },
)

export const mockEnrollmentDisclosuresCompanion = [
  mockGetEnrollmentDisclosuresCompanionData,
  mockSubmitEnrollmentDisclosuresCompanionData,
]
